
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(7(020|446|550)|(528|62|888)2|(124|665|911)6|5774|8184)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
